import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginScreen.css';
import { auth } from '../firebase';
import { signInWithPopup, GoogleAuthProvider, signInAnonymously } from 'firebase/auth';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import googleLogo from '../images/google-logo.png';
import { TermsContent } from './TermsContent';

const LoginScreen = ({ onLogin }) => {
  const [error, setError] = useState('');
  const [email, setEmail] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    setError('');
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      localStorage.setItem('user_id', user.uid);
      localStorage.setItem('user_name', user.displayName);
      onLogin(user.uid);
      navigate('/');
    } catch (err) {
      setError('Error al iniciar sesión con Google');
    }
  };

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    if (!email) return;

    try {
      // 1. Anonymous Login
      const result = await signInAnonymously(auth);
      const user = result.user;

      // 2. Capture Lead Data
      await addDoc(collection(db, 'leads'), {
        email: email,
        uid: user.uid,
        createdAt: serverTimestamp(),
        userAgent: window.navigator.userAgent,
        platform: window.navigator.platform,
      });

      // 3. Set Local Storage & Navigate
      localStorage.setItem('user_id', user.uid);
      // Use email as name since anonymous users don't have a display name
      localStorage.setItem('user_name', email.split('@')[0]);

      onLogin(user.uid);
      navigate('/');
    } catch (err) {
      console.error("Error logging in:", err);
      setError('Error al iniciar sesión. Por favor intenta de nuevo.');
    }
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const isButtonEnabled = isValidEmail(email) && termsAccepted;
  const isGoogleButtonEnabled = termsAccepted;

  const handleAcceptTerms = () => {
    setTermsAccepted(true);
    setShowModal(false);
  };

  return (
    <div className="login-screen">
      <div className="login-container">
        <h1>Bienvenido a Zenthor</h1>
        <p>Inicia sesión para comenzar</p>
        <div className="login-form">
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '20px',
            justifyContent: 'center'
          }}>
            <input
              type="checkbox"
              id="terms-checkbox"
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
              style={{
                marginRight: '8px',
                cursor: 'pointer',
                width: '25px',
                height: '25px'
              }}
            />
            <label
              htmlFor="terms-checkbox"
              style={{
                fontSize: '0.85rem',
                color: '#666',
                cursor: 'pointer',
                userSelect: 'none',
                textAlign: 'left'
              }}
              onClick={(e) => {
                e.preventDefault();
                setShowModal(true);
              }}
            >
              Acepto los <span style={{ textDecoration: 'underline', color: '#4b8fa2' }}>Términos y Condiciones y la Política de Privacidad</span>
            </label>
          </div>

          <button
            className="google-login-button"
            onClick={handleGoogleLogin}
            disabled={!isGoogleButtonEnabled}
            style={{
              opacity: isGoogleButtonEnabled ? 1 : 0.5,
              cursor: isGoogleButtonEnabled ? 'pointer' : 'not-allowed'
            }}
          >
            <img src={googleLogo} alt="Google logo" className="google-logo" />
            <span>Ingresar con Google</span>
          </button>

          <form onSubmit={handleEmailLogin} className="input-group" style={{
            marginTop: ' 0px',
          }}>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Tu email"
              className="name-input"
              autoComplete="email"
            />
            <button
              type="submit"
              className={`login-button ${!isButtonEnabled ? 'disabled' : ''}`}
              disabled={!isButtonEnabled}
              style={{
                marginTop: '10px',
                background: isButtonEnabled ? 'linear-gradient(174deg, #1d295f 0%, #4b8fa2 100%)' : '#ccc',
                cursor: isButtonEnabled ? 'pointer' : 'not-allowed'
              }}
            >
              Ingresa tu correo para continuar
            </button>
          </form>

          {error && <span className="error-message">{error}</span>}
        </div>

        {showModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}>
            <div style={{
              backgroundColor: 'white',
              padding: '30px',
              borderRadius: '12px',
              maxWidth: '600px',
              maxHeight: '80vh',
              overflow: 'auto',
              position: 'relative',
              width: '80%',
              textAlign: 'left'
            }}>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#666',
                  lineHeight: '1'
                }}
              >
                ×
              </button>

              <h2 style={{ marginTop: 0, color: '#1d295f', textAlign: 'center' }}>TÉRMINOS Y CONDICIONES</h2>

              <TermsContent />

              <button
                onClick={handleAcceptTerms}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'linear-gradient(174deg, #1d295f 0%, #4b8fa2 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  cursor: 'pointer'
                }}
              >
                Acepto los términos
              </button>
            </div>
          </div>
        )}

        <p style={{
          fontSize: '0.74rem',
          color: '#999',
          textAlign: 'justify',
          marginTop: '20px',
          lineHeight: '1.4',
          maxWidth: '90%',
          margin: '30px auto 0',
          opacity: '0.8'
        }}>
          Zenthor no brinda terapia psicológica ni diagnósticos clínicos. No sustituye la atención de profesionales en salud mental.<br />
        </p>
      </div>
    </div >
  );
};

export default LoginScreen; 